import { LocaleId, TranslationDictionaryMapping } from '@i18n';
import { BasketTranslationDictionary } from './basket-translation-dictionary.interface';

export const translation: TranslationDictionaryMapping<BasketTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      SINGLE_PLAN_SALE_PAGE_FOOTER_PROMO_DISCOUNTED_MONTHS_LINE:
        '{{ discountedPrice }} a month for {{ months }} months, ',
      SINGLE_PLAN_SALE_PAGE_FOOTER_PROMO_MONTHS_FREE_LINE:
        'First {{ freeMonths }} months FREE, ',
      SINGLE_PLAN_SALE_PAGE_FOOTER_PROMO_FULL_PRICE:
        'then {{ fullPrice }} a month',
      SINGLE_PLAN_SALE_PAGE_FOOTER_PROMO_FULL_PRICE_VERBOSE:
        'then following monthly payments are {{ fullPrice }} unless cancelled.',
    },
    [LocaleId.English_Ireland]: {
      SINGLE_PLAN_SALE_PAGE_FOOTER_PROMO_DISCOUNTED_MONTHS_LINE:
        '{{ discountedPrice }} a month for {{ months }} months, ',
      SINGLE_PLAN_SALE_PAGE_FOOTER_PROMO_MONTHS_FREE_LINE:
        'First {{ freeMonths }} months FREE, ',
      SINGLE_PLAN_SALE_PAGE_FOOTER_PROMO_FULL_PRICE:
        'then {{ fullPrice }} a month',
      SINGLE_PLAN_SALE_PAGE_FOOTER_PROMO_FULL_PRICE_VERBOSE:
        'then following monthly payments are {{ fullPrice }} unless cancelled.',
    },
  };
